import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Box, Typography, CircularProgress, Alert, Paper } from '@mui/material';

export default function PaymentSuccess() {
    const [searchParams] = useSearchParams();
    const sessionId = searchParams.get('session_id');

    console.log('sessionId', sessionId)

    const [loading, setLoading] = useState(true);
    const [sessionData, setSessionData] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!sessionId) {
            setError('Brak sessionId w URL');
            setLoading(false);
            return;
        }

        // fetch(`http://localhost:1337/strapi-stripe/retrieveCheckoutSession/${sessionId}`, {
        fetch(`http://localhost:1337/api/stripe/retrieveCheckoutSession/${sessionId}`, {
            method: 'GET',
        })
            .then((res) => {
                if (!res.ok) {
                    throw new Error(`Błąd serwera: ${res.status}`);
                }
                return res.json();
            })
            .then((data) => {
                setSessionData(data);
                setLoading(false);
            })
            .catch((err) => {
                setError(err.message);
                setLoading(false);
            });
    }, [sessionId]);

    console.log('sessionData', sessionData)

    if (loading) {
        return (
            <Box display="flex" justifyContent="center" mt={10}>
                <CircularProgress />
            </Box>
        );
    }

    if (error) {
        return (
            <Box maxWidth={600} mx="auto" mt={10}>
                <Alert severity="error">{error}</Alert>
            </Box>
        );
    }

    return (
        <Box maxWidth={600} mx="auto" mt={10}>
            <Paper elevation={3} sx={{ p: 4, textAlign: 'center' }}>
                <Typography variant="h4" gutterBottom>
                    Płatność zakończona sukcesem!
                </Typography>
                <Typography variant="body1" gutterBottom>
                    Dziękujemy za dokonanie płatności.
                </Typography>

                <Typography variant="subtitle1" sx={{ mt: 2 }}>
                    <strong>ID sesji:</strong> {sessionData?.id}
                </Typography>

                <Typography variant="subtitle1">
                    <strong>Status płatności:</strong> {sessionData?.payment_status}
                </Typography>

                <Typography variant="subtitle1">
                    <strong>Kwota:</strong>{' '}
                    {(sessionData?.amount_total / 100).toFixed(2)}{' '}
                    {sessionData?.currency?.toUpperCase()}
                </Typography>

                <Typography variant="subtitle1" sx={{ mt: 2 }}>
                    <strong>Email klienta:</strong> {sessionData?.customer_email}
                </Typography>

                <Typography variant="subtitle1">
                    <strong>Produkt:</strong> {sessionData?.metadata?.productName}
                </Typography>

                <Typography variant="subtitle1">
                    <strong>ID produktu:</strong> {sessionData?.metadata?.productId}
                </Typography>

                <Typography variant="subtitle1" sx={{ mt: 2 }}>
                    Jeśli masz pytania, skontaktuj się z nami.
                </Typography>
            </Paper>
        </Box>
    );
}
